import { TreeNode } from "@/types/tree";

// Inline Editor Actions API
// Similar to breakdanceStoreActions, this provides hooks for reacting to inline editor lifecycle events

type OnBeforeClosingInlineEditorCallback = (args: {
  elementId: TreeNode["id"];
  childrenIds: TreeNode["id"][];
}) => void;

class InlineEditorActions {
  private callbacks: {
    onBeforeClosingInlineEditor: OnBeforeClosingInlineEditorCallback[];
  } = {
    onBeforeClosingInlineEditor: []
  };

  register = {
    onBeforeClosingInlineEditor: (callback: OnBeforeClosingInlineEditorCallback) => {
      this.callbacks.onBeforeClosingInlineEditor.push(callback);
    }
  };

  run = {
    onBeforeClosingInlineEditor: (args: {
      elementId: TreeNode["id"];
      childrenIds: TreeNode["id"][];
    }) => {
      this.callbacks.onBeforeClosingInlineEditor.forEach(callback =>
        callback(args)
      );
    }
  };
}

export const inlineEditorActions = new InlineEditorActions();
